import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {addToast, removeToast, toggleToasts} from "./toastsSlice";

export const ReduxToastsComponent = () => {
  const dispatch = useDispatch();
  const toasts = useSelector(state => state.toasts.list);

  return (
    <>
      <button onClick={() => dispatch(toggleToasts())}>
        Show toasts
      </button>
      <br />
      <button onClick={() => dispatch(addToast(new Date().getTime()))}>
        Add toast
      </button>
      <br />
      {
        toasts.map(toast => (
          <div key={toast}>
            Toast with id: {toast}
            <br />
            <button onClick={() => dispatch(removeToast(toast))}>Remove me</button>
          </div>
        ))
      }
    </>
  )
};

